import { Component, OnInit } from '@angular/core';
import { environment } from '../../../';
import { CookieManagerService, ErrorManagerService, BasicTimerService, HttpClientService, GoogleService } from '../../../shared/';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoginService } from '../services/login.service';
import { CookieNames, AuthTypes, BasicRoutes, ApiEndpoints } from '../../constant';
import { User, PaperSet } from '../../model';
import { LocalStorageService } from 'angular-2-local-storage';
import { LoginTypes } from '../../constant';

@Component({
    selector: 'redirect',
    template: '<div class="gp5loading"><div class="loadergp5"></div></div>',
    providers: [GoogleService]
})
export class RedirectComponent implements OnInit {
    public authType: string;
    public token: string;
    public setid: string;
    public access_token: string;

    constructor(
        private route: ActivatedRoute,
        private loginService: LoginService,
        private cookieManagerService: CookieManagerService,
        private httpClientService: HttpClientService,
        private localStorageService: LocalStorageService,
        private router: Router,
        private BasicTimerService: BasicTimerService,
        private googleService: GoogleService) { }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            this.authType = params[AuthTypes.type];
            this.token = params[AuthTypes.token];
            this.setid = params[AuthTypes.setid];
            this.access_token = params[AuthTypes.access_token];
        });

        switch (this.authType) {
            case AuthTypes.FACEBOOK:
                window.location.href = ApiEndpoints.facebookAuth;
                break;
            case AuthTypes.GOOGLE:
                window.location.href = ApiEndpoints.googleAuth;
                break;
        };

        if (this.token) {
            this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.web, false, 1);
            this.localStorageService.set(CookieNames.loginType, LoginTypes.web);
            this.loginService.loginByaccessToken(this.token).subscribe(user => {
                this.loginUser(user).then((response: any) => {
                    this.router.navigate([BasicRoutes.clientExams]);
                });
            },error => {
                this.router.navigate([BasicRoutes.login]);
            });
        }

        if (this.access_token) {
            this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.mobile, false, 1);
            this.localStorageService.set(CookieNames.loginType, LoginTypes.mobile);
            this.httpClientService.get(ApiEndpoints.getPaymentCode + this.access_token).subscribe(res => {
                this.cookieManagerService.setCookie(CookieNames.paperSet , res.paperSet, true, 1);
                let id = res.paperSet._id;
                this.loginUser(res).then((response: any) => {
                    if(id){
                        this.router.navigate(['home/exams/' + id + '/payment']);
                    }
                });
            }, error => {
                window.location.replace(ApiEndpoints.MOBILE_APP_URL);
            });
        }
    }

    loginUser(user: User) {
        return new Promise((resolve, reject) => {
            if (user) {
                this.googleService.emitEvent("SocialLogin", "SocialLogin", user.username, 1);
                this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify({
                    firstname: user.username
                }), false, 1);
                this.cookieManagerService.setCookie(CookieNames.points, user.points, false, 1);
                this.cookieManagerService.setCookie(CookieNames.district, JSON.stringify({
                    isDistrictNeed: user.isDistrictNeed
                }), false, 1);
                this.localStorageService.set(CookieNames.userImage, user.image);
                let selectedUser = new User(user);
                this.cookieManagerService.setCookie(CookieNames.name, selectedUser.getDisplayName(), false, 1);
                this.cookieManagerService.setCookie(CookieNames.username, user.username, false, 1);
                this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + user.token, false, 1);
                resolve();
            } else {
                reject();
            }
        });
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/components/redirect.component.ts